export default {
  order_methods: {
    delivery: 'Entrega',
    pickup: 'Takeaway',
    room_service: 'No local',
    table_service: 'No local',
  },
  time: '{{time}} min',
  asap: 'ASAP',
  unavailable: 'Indisponível',
  ready_in: 'Pronto em ',
  buttons: {
    change: 'Alterar',
    see_hours: 'Ver horário',
    change_location: 'Alterar localização',
    change_time: 'Alterar hora',
  },
};
